module.exports = "varying vec2 vUv;\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/wood-vert.glsl
// module id = 10
// module chunks = 0